<template>
  <div class='h100vh-100 h-normalBg'>
    <div class='row h-nomargin h-full-container h100-80'>
      <div id="eCharts" ref="eCharts" class='h100'>
      </div>
    </div>
    <CustomDialog ref='NoRealTaskReportMeasurementDialog' :element='NoRealTaskReportMeasurementDialog.element' :styles='NoRealTaskReportMeasurementDialog.style'>
      <template v-slot:dialog-content>
        <NoRealTaskMeasurementReportDialog ref="NoRealTaskReportMeasurement" :selectNeId="selectNeId" :selectNeType="selectNeType"></NoRealTaskMeasurementReportDialog>
      </template>
    </CustomDialog>

    <CustomDialog ref='NoRealTaskResourceReportDialog1' :element='NoRealTaskResourceReportDialog1.element' :styles='NoRealTaskResourceReportDialog1.style'>
      <template v-slot:dialog-content>
        <NoRealTaskResourceReportDialog1 ref="NoRealTaskReportResource1" :selectNeType="selectNeType"></NoRealTaskResourceReportDialog1>
      </template>
    </CustomDialog>
    <CustomDialog ref='NoRealTaskResourceReportDialog2' :element='NoRealTaskResourceReportDialog2.element' :styles='NoRealTaskResourceReportDialog2.style'>
      <template v-slot:dialog-content>
        <NoRealTaskResourceReportDialog2 ref="NoRealTaskReportResource2" :selectNeId="selectNeId" :selectNeType="selectNeType"></NoRealTaskResourceReportDialog2>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
  import eCharts from 'echarts';
  import NoRealTaskMeasurementReportDialog from "./dialog/NoRealTaskMeasurementReportDialog";
  import NoRealTaskResourceReportDialog1 from "./dialog/NoRealTaskResourceReportDialog1";
  import NoRealTaskResourceReportDialog2 from "./dialog/NoRealTaskResourceReportDialog2";
  import CustomDialog from "../../../../common/CustomDialog";
  import {PmEventBus} from "../../../util/PmEventBus";
  import Vue from "vue";
  import DateUtil from "../../../util/DateUtil";
  import {EventBus} from "../../../../../plugins/eventBus";

  Vue.prototype.$echarts = eCharts;

  export default {
    name: 'PmNoRealReportRightContent',
    components: {
      CustomDialog,
      NoRealTaskMeasurementReportDialog,
      NoRealTaskResourceReportDialog1,
      NoRealTaskResourceReportDialog2
    },
    data() {
      return {
        selectNeId: 1,
        selectNeType: 101,
        NoRealTaskReportMeasurementDialog: {
          style: {
            width: '800px',
            height: '760px',
            visible: false,
            model: true
          },
          element: {
            title: this.$t('Pm.multiMeasureObjChart'),
            target: this.$refs.PmNoRealTaskQueryList,
            refName: 'NoRealTaskReportMeasurementDialogElement',
            buttonGroup: [
              { click: this.closeNoRealTaskMeasurementReportDialog, buttonModel: { content: this.$t('Common.cancel') } },
              { click: this.noRealTaskMeasurementReportBegin, buttonModel: { content: this.$t('Pm.query'), isPrimary: true }},
            ],
            isClose: true
          }
        },

        NoRealTaskResourceReportDialog1: {
          style: {
            width: '800px',
            height: 'auto',
            visible: false,
            model: true
          },
          element: {
            title: this.$t('Pm.multiResourceChart'),
            target: this.$refs.PmNoRealTaskQueryList,
            refName: 'NoRealTaskResourceReportDialog1Element',
            buttonGroup: [
              { click: this.closeNoRealTaskResourceReportDialog1, buttonModel: { content: this.$t('Common.cancel') } },
              { click: this.nextForNoRealTaskResourceReport, buttonModel: { content: this.$t('Pm.next'), isPrimary: true }},
            ],
            isClose: true
          }
        },

        NoRealTaskResourceReportDialog2: {
          style: {
            width: '800px',
            height: 'auto',
            visible: false,
            model: true
          },
          element: {
            title: this.$t('Pm.multiResourceChartQuery'),
            target: this.$refs.PmNoRealTaskQueryList,
            refName: 'NoRealTaskResourceReportDialog2Element',
            buttonGroup: [
              { click: this.closeNoRealTaskResourceReportDialog2, buttonModel: { content: this.$t('Common.cancel') } },
              { click: this.preForNoRealTaskResourceReport, buttonModel: { content: this.$t('Pm.previous') }},
              { click: this.noRealTaskResourceReportBegin, buttonModel: { content: this.$t('Pm.complete'), isPrimary: true }}
            ],
            isClose: true
          }
        },

        myCharts: {},
        paramsOfDialog1: {}
      };
    },
    methods: {

      myECharts(){
        // 基于准备好的dom，初始化echarts实例
        this.myCharts = this.$echarts.init(this.$refs.eCharts);
      },

      closeNoRealTaskMeasurementReportDialog(){
        this.$refs.NoRealTaskReportMeasurementDialog.clear();
        this.$refs.NoRealTaskReportMeasurementDialog.close();
      },


      noRealTaskMeasurementReportBegin(){
        const ruleDatas = this.$refs.NoRealTaskReportMeasurement.validateOfNoRealMeasurementReport();
        if (!ruleDatas) {
          return;
        }

        const nodeCheckList =  this.$refs.NoRealTaskReportMeasurement.$refs.NoRealTaskMeasureTreeForSingleReport.nodeCheckIdListForSingleReport;

        if(nodeCheckList.length < 1) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.pleaseSelectCounter')});
          return;
        }

        const nodeCheckInfoList =  this.$refs.NoRealTaskReportMeasurement.$refs.NoRealTaskMeasureTreeForSingleReport.nodeCheckInfoListForSingleReport;

        if(nodeCheckList.length > 9) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.mostNineCounterCanView')});
          return;
        }
        const sampleTime = this.$refs.NoRealTaskReportMeasurement.sampleTimeOfSingleReport.toString();
        const startTime = DateUtil.getDateString(this.$refs.NoRealTaskReportMeasurement.startTimeForSingle);
        const endTime = DateUtil.getDateString(this.$refs.NoRealTaskReportMeasurement.endTimeForSingle);
        const measureObjCode = this.$refs.NoRealTaskReportMeasurement.measureObjCodeOfSingleReport;

        this.$loading.showLoadding(this.$t('System.loading'));
        this.$axios.post('/lte/ems/pm/noReal/report/getReportData.html', {
          startTime,
          endTime,
          measureObjCode,
          sampleTime,
          nodeCheckList,
          neId: this.selectNeId,
          neTypeCode: this.selectNeType
        }).then((response) => {
          const result = response.data.resultVal;
          if(result == null || result.length == 0){
            EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.resultEmpty')});
            this.$loading.hideLoadding();
          } else{
            let xAxisList = result.map(function (xAxisData) {
              return DateUtil.getDateString(new Date(xAxisData.end_time));
            })

            let legendListData = [];

            let yAxisData = {};

            for(let resultKey in result[0]){
              if(resultKey.indexOf("C00") != -1 || resultKey.indexOf("K00") != -1 || resultKey.indexOf("U00") != -1){
                legendListData.push(nodeCheckInfoList[resultKey].text);
                yAxisData[resultKey] = {
                  name: nodeCheckInfoList[resultKey].text,
                  type: 'line',
                  connectNulls:true,
                  data: []
                };
              }
            }

            let legend = {
              top: 30,
              data: legendListData
            }

            let series = [];

            for(let resultData of result){
              for(let key in resultData){
                if(key.indexOf("C0") != -1 || key.indexOf("K0") != -1 || key.indexOf("U0") != -1){
                  yAxisData[key].data.push(resultData[key]);
                }
              }
            }

            for(let serie in yAxisData){
              series.push(yAxisData[serie]);
            }

            const title = {
              textAlign: 'center',
              text: this.$t('Pm.pmDataLineChart'),
              textStyle: {
                fontSize: 20,
                fontWeight: 'bolder'
              },
              top: '0',
              left: '50%'
            };

            const options = {
              title: title,
              tooltip: {
                trigger: 'axis'
              },
              legend : legend,
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              toolbox: {
                feature: {
                  saveAsImage: {}
                }
              },
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: xAxisList
              },
              dataZoom:{
                type: 'slider',
                show: true,
                xAxisIndex: [0],
                bottom: -10,
                startValue: 0,
                endValue: 10,
                rangeMode: ['value','value']
              },
              yAxis: {
                type: 'value',
              },
              series: series
            }

            this.myCharts.setOption(options);
            this.$loading.hideLoadding();
          }
        });
        this.$refs.NoRealTaskReportMeasurementDialog.clear();
        this.$refs.NoRealTaskReportMeasurementDialog.close();
      },


      closeNoRealTaskResourceReportDialog1(){
        this.$refs.NoRealTaskResourceReportDialog1.clear();
        this.$refs.NoRealTaskResourceReportDialog1.close();
      },

      nextForNoRealTaskResourceReport(){

        let nodeCheckIdList = this.$refs.NoRealTaskReportResource1.nodeCheckIdListForResourceReport;

        if(nodeCheckIdList == null || nodeCheckIdList.length == 0){
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.pleaseSelectNe')});
          return;
        }

        this.paramsOfDialog1 = {
          nodeCheckIdList: nodeCheckIdList,
          startTime: DateUtil.getDateString(this.$refs.NoRealTaskReportResource1.startTimeForResource),
          endTime: DateUtil.getDateString(this.$refs.NoRealTaskReportResource1.endTimeForResource),
          sampleTime: this.$refs.NoRealTaskReportResource1.sampleTimeOfResourceReport.toString()
        }

        this.$refs.NoRealTaskReportResource2.getMeasureListForResourceReport(this.selectNeType);

        this.$refs.NoRealTaskResourceReportDialog1.close();
        this.$refs.NoRealTaskResourceReportDialog2.show();
      },

      closeNoRealTaskResourceReportDialog2(){
        this.$refs.NoRealTaskResourceReportDialog2.clear();
        this.$refs.NoRealTaskResourceReportDialog2.close();
      },
      preForNoRealTaskResourceReport(){
        this.paramsOfDialog1 = {}
        this.$refs.NoRealTaskResourceReportDialog2.close();
        this.$refs.NoRealTaskResourceReportDialog1.show();
      },
      noRealTaskResourceReportBegin(){

        let measureObjCode = this.$refs.NoRealTaskReportResource2.measureObjCodeOfResourceReport;
        if(measureObjCode == null || measureObjCode == 1){
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.pleaseSelectMeasureObj')});
          return;
        }

        let counterCode = this.$refs.NoRealTaskReportResource2.$refs.NoRealTaskMeasureTreeForResourceReport.nodeCheckIdForResourceReport;
        if(counterCode == null || counterCode == 1){
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.pleaseSelectCounter')});
          return;
        }

        let counterCodeInfo = this.$refs.NoRealTaskReportResource2.$refs.NoRealTaskMeasureTreeForResourceReport.nodeCheckInfoForResourceReport;

        this.$loading.showLoadding(this.$t('System.loading'));
        this.$axios.post('/lte/ems/pm/noReal/report/getReportDataForResource.html', {
          startTime: this.paramsOfDialog1.startTime,
          endTime: this.paramsOfDialog1.endTime,
          measureObjCode,
          sampleTime: this.paramsOfDialog1.sampleTime,
          counterCode,
          neIdList: this.paramsOfDialog1.nodeCheckIdList,
          neTypeCode: this.selectNeType
        }).then((response) => {
          const result = response.data.resultVal;
          if(result == null || result.length == 0){
            EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.resultEmpty')});
            this.$loading.hideLoadding();
          }else{
            let xAxisList = result[0].map(function (xAxisData) {
              return DateUtil.getDateString(new Date(xAxisData.end_time));
            })

            let legendListData = [];

            let yAxisData = {};

            result.forEach((resultContent) => {
              legendListData.push(resultContent[0].ne_name);
              yAxisData[resultContent[0].ne_name] = {
                name: resultContent[0].ne_name,
                type: 'line',
                connectNulls:true,
                data: []
              }
            })

            let legend = {
              top: 30,
              data: legendListData
            }

            let series = [];

            for(let resultData of result){
              resultData.forEach((resultIn) => {
                yAxisData[resultData[0].ne_name].data.push(resultIn[counterCode]);
              })
            }

            for(let serie in yAxisData){
              series.push(yAxisData[serie]);
            }

            const title = {
              textAlign: 'center',
              text: `${counterCodeInfo.text}${this.$t('Pm.pmDataLineChart')}`,
              textStyle: {
                fontSize: 20,
                fontWeight: 'bolder'
              },
              top: '0',
              left: '50%'
            };

            const options = {
              title: title,
              tooltip: {
                trigger: 'axis'
              },
              legend : legend,
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              toolbox: {
                feature: {
                  saveAsImage: {}
                }
              },
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: xAxisList
              },
              dataZoom:{
                type: 'slider',
                show: true,
                xAxisIndex: [0],
                bottom: -10,
                startValue: 0,
                endValue: 10,
                rangeMode: ['value','value']
              },
              yAxis: {
                type: 'value',
              },
              series: series
            }

            this.myCharts.setOption(options);

            this.$loading.hideLoadding();
          }
        });
        this.$refs.NoRealTaskResourceReportDialog2.clear();
        this.$refs.NoRealTaskResourceReportDialog2.close();
      },

    },
    mounted() {
      PmEventBus.$on('measurementReport',() => {
        this.$refs.NoRealTaskReportMeasurement.bindValidateOfMeasurementReport();
        this.$refs.NoRealTaskReportMeasurement.getMeasureListForMeasurementReport(this.selectNeType);
        this.$refs.NoRealTaskReportMeasurementDialog.show();
      })

      PmEventBus.$on('resourceReport',() => {
        this.$refs.NoRealTaskReportResource1.getNoRealTaskResourceTree();
        this.$refs.NoRealTaskResourceReportDialog1.show();
      })

      PmEventBus.$on('transferNodeInfoOfResourceTreeSelected',(node) => {
        console.log(node);
        if(node.nodeData.parentID != null && node.nodeData.parentID != 'root'){
          this.selectNeId = node.nodeData.id;
          this.selectNeType = node.nodeData.parentID.split('_')[1];
        } else if(node.nodeData.parentID == 'root'){
          this.selectNeId = '';
          this.selectNeType = node.nodeData.id.split('_')[1];
        }
      })

      this.myECharts();
    },
    watch: {
    }
  };
</script>

<style>

</style>
